import { lazy } from 'react';

const Home = lazy(() => import('./pages/Home'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Academic = lazy(() => import('./pages/Academic'));
const Courses = lazy(() => import('./pages/Courses'));
const Career = lazy(() => import('./pages/Career'));
const Gallery = lazy(() => import('./pages/Gallery'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Events = lazy(() => import('./components/Events'));

const routes = [
  {
    path: '/',
    component: Home,
    exact: true
  },
  {
    path: '/about-us',
    component: AboutUs
  },
  {
    path: '/academic',
    component: Academic
  },
  {
    path: '/courses',
    component: Courses
  },
  {
    path: '/career',
    component: Career
  },
  {
    path: '/gallery',
    component: Gallery
  },
  {
    path: '/contact-us',
    component: ContactUs
  },
  {
    path: '/events',
    component: Events
  }
];

export default routes;
